import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, EMPTY, tap } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { TokenUsage } from '../interfaces/token-usage.interface';

@Injectable({ providedIn: 'root' })
export class TokenUsageService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(AppConfigService);
  private readonly _tokenUsage = signal<TokenUsage | null>(null);
  private readonly _tokenUsageFailed = signal<boolean>(false);

  /** Read-only signal exposing the current token usage. */
  readonly tokenUsage = this._tokenUsage.asReadonly();

  /** Read-only signal indicating the last load() call failed. */
  readonly tokenUsageFailed = this._tokenUsageFailed.asReadonly();

  private get url(): string {
    return `${this.configService.apiBaseUrl}/api/v2/usage/tokens`;
  }

  /** Fetches the current billing period token usage and updates signals. */
  load(): void {
    this.http.get<TokenUsage>(this.url)
      .pipe(
        tap(() => this._tokenUsageFailed.set(false)),
        catchError(() => {
          this._tokenUsageFailed.set(true);
          return EMPTY;
        })
      )
      .subscribe(result => this._tokenUsage.set(result));
  }

  /** Returns the token usage as an Observable for consumers that prefer reactive streams. */
  getUsage() {
    return this.http.get<TokenUsage>(this.url);
  }
}
